import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { UserLogMaster } from "./UserLogMaster";

const UserLogManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <UserLogMaster />} />
  </Switch>
);

export const UserLogManagement = withRouter(UserLogManagementRoutes);
